import {
  addDays,
  endOfDay,
  startOfDay,
  startOfMonth,
  endOfMonth,
  addMonths,
  startOfYear,
  endOfYear,
  isSameDay,
  differenceInCalendarDays,
} from 'date-fns';

const defineds = {
  startOfToday: startOfDay(new Date()),
  endOfToday: endOfDay(new Date()),
  startOfLast7Days: startOfDay(addDays(new Date(), -6)),
  startOfLast30Days: startOfDay(addDays(new Date(), -29)),
  startOfLast3Months: startOfMonth(addMonths(new Date(), -3)),
  startOfLast12Months: startOfMonth(addMonths(new Date(), -12)),
  startOfMonth: startOfMonth(new Date()),
  endOfMonth: endOfMonth(new Date()),
  startOfYear: startOfYear(new Date()),
  endOfYear: endOfYear(new Date()),
  allTimeStart: new Date(0), // Epoch time for "All time"
};

const staticRangeHandler = {
  range: {},
  isSelected(range) {
    const definedRange = this.range();
    return (
      isSameDay(range.startDate, definedRange.startDate) &&
      isSameDay(range.endDate, definedRange.endDate)
    );
  },
};

export function createStaticRanges(ranges) {
  return ranges.map((range) => ({ ...staticRangeHandler, ...range }));
}

export const defaultStaticRanges = createStaticRanges([
  {
    label: 'Today',
    range: () => ({
      startDate: defineds.startOfToday,
      endDate: defineds.endOfToday,
    }),
  },
  {
    label: 'Last 7 days',
    range: () => ({
      startDate: defineds.startOfLast7Days,
      endDate: defineds.endOfToday,
    }),
  },
  {
    label: 'Last 30 days',
    range: () => ({
      startDate: defineds.startOfLast30Days,
      endDate: defineds.endOfToday,
    }),
  },
  {
    label: 'Last 3 months',
    range: () => ({
      startDate: defineds.startOfLast3Months,
      endDate: defineds.endOfToday,
    }),
  },
  {
    label: 'Last 12 months',
    range: () => ({
      startDate: defineds.startOfLast12Months,
      endDate: defineds.endOfToday,
    }),
  },
  {
    label: 'Month to date',
    range: () => ({
      startDate: defineds.startOfMonth,
      endDate: defineds.endOfToday,
    }),
  },
  {
    label: 'Year to date',
    range: () => ({
      startDate: defineds.startOfYear,
      endDate: defineds.endOfToday,
    }),
  },
  {
    label: 'All time',
    range: () => ({
      startDate: defineds.allTimeStart,
      endDate: defineds.endOfToday,
    }),
  },
]);

export const defaultInputRanges = [
  {
    label: 'days up to today',
    range(value) {
      return {
        startDate: addDays(
          defineds.startOfToday,
          (Math.max(Number(value), 1) - 1) * -1
        ),
        endDate: defineds.endOfToday,
      };
    },
    getCurrentValue(range) {
      if (!isSameDay(range.endDate, defineds.endOfToday)) return '-';
      if (!range.startDate) return '∞';
      return differenceInCalendarDays(defineds.endOfToday, range.startDate) + 1;
    },
  },
  {
    label: 'days starting today',
    range(value) {
      const today = new Date();
      return {
        startDate: today,
        endDate: addDays(today, Math.max(Number(value), 1) - 1),
      };
    },
    getCurrentValue(range) {
      if (!isSameDay(range.startDate, defineds.startOfToday)) return '-';
      if (!range.endDate) return '∞';
      return differenceInCalendarDays(range.endDate, defineds.startOfToday) + 1;
    },
  },
];
